<template>
  <form class="form" @submit.prevent="saveProfile">
    <h2 class="form__title">
      {{ $t('settings.profile["My Profile"]') }}
    </h2>
    <FormGroup :errors="formErrors" name="avatar">
      <UploadAvatar />
    </FormGroup>
    <FormGroup :errors="formErrors" name="firstName">
      <label for="firstName" class="form__label">{{ $t('form.user["First Name:"]') }}</label>
      <input id="firstName" v-model="firstName" class="form__control" type="text" />
    </FormGroup>
    <FormGroup :errors="formErrors" name="lastName">
      <label for="lastName" class="form__label">{{ $t('form.user["Last Name:"]') }}</label>
      <input id="lastName" v-model="lastName" class="form__control" type="text" />
    </FormGroup>
    <FormGroup :errors="formErrors" name="sex">
      <label class="form__label">{{ $t('form.user["Sex:"]') }}</label>
      <div class="form-radio-group block">
        <Radio v-model="sex" class="mr-2" name="sex" trueValue="H">{{ $t('form.user["Male"]') }}</Radio>
        <Radio v-model="sex" class="mr-2" name="sex" trueValue="F">{{ $t('form.user["Female"]') }}</Radio>
      </div>
    </FormGroup>
    <FormGroup :errors="formErrors" name="rating">
      <label for="rating" class="form__label">{{ $t('form.user["Rating:"]') }}</label>
      <SelectRating
        id="rating"
        v-model="rating"
        :country="country"
        class="form__control"
      />
    </FormGroup>
    <div class="form__group">
      <label for="licence" class="form__label">{{ $t('form.user["Licence:"]') }}</label>
      <input
        id="licence"
        v-model="licence"
        disabled
        class="form__control"
        type="text"
      /> ({{ $t('global["not editable"]') }})
    </div>
    <FormGroup :errors="formErrors" name="club">
      <label for="club" class="form__label">
        {{ $t('form.user["Club Number:"]') }}
      </label>
      <input
        id="club"
        v-model="club"
        class="form__control"
        type="text"
      /> (8 chiffres)
    </FormGroup>
    <FormGroup :errors="formErrors" name="birthyear">
      <label for="birthyear" class="form__label">
        {{ $t('form.user["Birth Year:"]') }}
      </label>
      <SelectYear id="birthyear" v-model="birthyear" class="form__control" />
    </FormGroup>
    <FormGroup :errors="formErrors" name="racquet">
      <label for="racquet" class="form__label">
        {{ $t('form.user["Racquet:"]') }}
      </label>
      <SelectRacquet id="racquet" v-model="racquet" class="form__control" />
    </FormGroup>
    <div class="form__actions">
      <Button
        :disabled="saving"
        :loading="saving"
        :dirty="dirty"
        type="submit"
        icon="save"
        class="form__btn-submit"
      >
        {{ $t('global.Save') }}
      </Button>
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex';
import SelectRacquet from '@/components/Form/SelectRacquet.vue';
import SelectRating from '@/components/Form/SelectRating.vue';
import SelectYear from '@/components/Form/SelectYear.vue';
import FormGroup from '@/components/Form/FormGroup.vue';
import Radio from '@/components/Form/Radio.vue';
import { editUser } from '@/modules/api/user';
import UploadAvatar from './UploadAvatar.vue';

export default {
  components: {
    FormGroup,
    SelectYear,
    SelectRacquet,
    SelectRating,
    Radio,
    UploadAvatar,
  },

  data() {
    return {
      saving: false,
      dirty: true,
      formErrors: {},
    };
  },

  computed: {
    ...mapGetters(['country']),
  },

  beforeMount() {
    const { user } = this.$store.state;

    this.firstName = user.firstName;
    this.lastName = user.lastName;
    this.licence = user.licence;
    this.rating = user.rating && user.rating.label;
    this.birthyear = user.birthyear;
    this.club = user.club && user.club.id;
    this.racquet = user.racquet && user.racquet.brand;
    this.sex = user.sex;
  },

  methods: {
    saveProfile() {
      const formData = {
        firstName: this.firstName,
        lastName: this.lastName,
        licence: this.licence,
        rating: this.rating,
        birthyear: this.birthyear,
        club: this.club,
        racquet: this.racquet,
        sex: this.sex,
      };

      this.saving = true;
      this.formErrors = {};

      editUser(formData)
        .then(user => {
          this.$store.dispatch('EDIT_USER', user);
          this.formErrors = {};
          this.saving = false;
        })
        .catch(error => {
          if (error.response) {
            const { data } = error.response;
            this.formErrors = data.errors;
          }
          this.saving = false;
        });
    },
  },
};
</script>
